import {
    BrowserRouter as Router,
    Navigate,
    Route,
    Routes,
    Outlet
} from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { Routes as AppRoutes } from '../routes';
import Header from './common/header/Header';
import Footer from './common/footer/Footer';
import Home from './home/Home';
import ManualInput from './manualInput/ManualInput';
import PeriodStatus from './periodStatus/PeriodStatus';
import Brands from './brands/Brands';
import Countries from './countries/Countries';
import Divisions from './divisions/Divisions';
import EditDivision from './divisions/edit/EditDivision';
import LeadingBrands from './leadingBrands/LeadingBrands';
import Users from './users/Users';
import EditUser from './users/edit/EditUser';
import UsersAccessRights from './usersAccessRights/UsersAccessRights';
import ProductDetails from './productDetails/ProductDetails';
import WelcomeAdmin from './welcomeAdmin/WelcomeAdmin';
import ManageRemainders from './manageRemainders/ManageReminders';
import { AuthorizationError } from './errors/AuthorizationError';
import { ServiceShareInput } from './serviceShareInput/ServiceShareInput';
import { PrivateRoute } from './common/privateRoute/PrivateRoute';
import { ApplicationSections } from '../shared/userSecurityRoles';
import NotificationLogs from './notificationLogs/NotificationLogs';

const MainLayout = () => (
    <>
        <Header />
        <Outlet />
        <Footer />
    </>
);

const ErrorLayout = () => (
    <>
        <Outlet />
    </>
);

const AppRouter = (): JSX.Element => {
    return (
        <>
            <ToastContainer />
            <Router>
                <Routes>
                    <Route element={<ErrorLayout />}>
                        <Route
                            path={AppRoutes.authorizationError.pattern}
                            element={<AuthorizationError />}
                        />
                    </Route>
                    <Route element={<MainLayout />}>
                        <Route
                            path={AppRoutes.home.pattern}
                            element={<Home />}
                        />
                        <Route
                            path={AppRoutes.manualInput.pattern}
                            element={
                                <PrivateRoute
                                    sectionName={
                                        ApplicationSections.ManualInput
                                    }
                                >
                                    <ManualInput />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path={AppRoutes.serviceShareInput.pattern}
                            element={
                                <PrivateRoute
                                    sectionName={
                                        ApplicationSections.ServiceShareInput
                                    }
                                >
                                    <ServiceShareInput />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path={AppRoutes.periodStatus.pattern}
                            element={
                                <PrivateRoute
                                    sectionName={
                                        ApplicationSections.PeriodInputStatus
                                    }
                                >
                                    <PeriodStatus />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path={AppRoutes.users.pattern}
                            element={
                                <PrivateRoute
                                    sectionName={
                                        ApplicationSections.Administration
                                    }
                                >
                                    <Users />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path={AppRoutes.editUsers.pattern}
                            element={
                                <PrivateRoute
                                    sectionName={
                                        ApplicationSections.Administration
                                    }
                                >
                                    <EditUser />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path={AppRoutes.brands.pattern}
                            element={
                                <PrivateRoute
                                    sectionName={
                                        ApplicationSections.Administration
                                    }
                                >
                                    <Brands />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path={AppRoutes.countries.pattern}
                            element={
                                <PrivateRoute
                                    sectionName={
                                        ApplicationSections.Administration
                                    }
                                >
                                    <Countries />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path={AppRoutes.divisions.pattern}
                            element={
                                <PrivateRoute
                                    sectionName={
                                        ApplicationSections.Administration
                                    }
                                >
                                    <Divisions />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path={AppRoutes.editDivisions.pattern}
                            element={
                                <PrivateRoute
                                    sectionName={
                                        ApplicationSections.Administration
                                    }
                                >
                                    <EditDivision />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path={AppRoutes.leadingBrands.pattern}
                            element={
                                <PrivateRoute
                                    sectionName={
                                        ApplicationSections.Administration
                                    }
                                >
                                    <LeadingBrands />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path={AppRoutes.userAccessRights.pattern}
                            element={
                                <PrivateRoute
                                    sectionName={
                                        ApplicationSections.Administration
                                    }
                                >
                                    <UsersAccessRights />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path={AppRoutes.productDetails.pattern}
                            element={
                                <PrivateRoute
                                    sectionName={
                                        ApplicationSections.Administration
                                    }
                                >
                                    <ProductDetails />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path={AppRoutes.welcomeAdmin.pattern}
                            element={
                                <PrivateRoute
                                    sectionName={
                                        ApplicationSections.Administration
                                    }
                                >
                                    <WelcomeAdmin />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path={AppRoutes.manageReminders.pattern}
                            element={
                                <PrivateRoute
                                    sectionName={
                                        ApplicationSections.Administration
                                    }
                                >
                                    <ManageRemainders />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path={AppRoutes.notificationlogs.pattern}
                            element={
                                <PrivateRoute
                                    sectionName={ApplicationSections.Administration}
                                >
                                    <NotificationLogs />
                                </PrivateRoute>
                            }
                        />
						<Route
							path='*'
							element={<Navigate to={AppRoutes.home.pattern} />}
						/>
					</Route>
                </Routes>
            </Router>
        </>
    );
};

export default AppRouter;
